export enum UserRoleEnum {
  squadOwner = 'squadOwner',
  squadMember = 'squadMember',
  admin = 'admin',
}

export type UserRoleType = UserRoleEnum;
